/**
 * 本文件主要是调用基础功能
 */

// 设置时间轴当前时间
function setCurrentTime (newDate, self) {
  self = self || this
  const viewer = self.viewer
  //  if(typeof newDate === )
  viewer.clockViewModel.currentTime = Cesium.JulianDate.fromDate(newDate)
  return viewer
}

// 设置时间轴状态
function setTimeLineStatus (newDate, self) {
  return setCurrentTime(newDate, self)
}

// 设置动画状态
function setAnimateStatus (shouldAnimate, self) {
  self = self || this
  const viewer = self.viewer
  if (shouldAnimate === true || shouldAnimate === false) {
    viewer.clock.shouldAnimate = shouldAnimate
    return true
  }
  return false
}

// 开启灯光
function openLighting (self) {
  self = self || this
  const viewer = self.viewer
  // const viewer = this.viewer
  viewer.scene.globe.enableLighting = true
  // viewer.clock.shouldAnimate = true
}

function closeLighting (self) {
  self = self || this
  const viewer = self.viewer
  // const viewer = this.viewer
  viewer.scene.globe.enableLighting = false
  // viewer.clock.shouldAnimate = false
}

function setLighting (date, self) {
  self = self || this
  const viewer = self.viewer
  // const viewer = this.viewer
  viewer.clockViewModel.currentTime = Cesium.JulianDate.fromDate(date)
  // viewer.timeline.updateFromClock()
}

function openAtmosphere (self) {
  self = self || this
  const viewer = self.viewer
  viewer.scene.globe.showGroundAtmosphere = true
}

function closeAtmosphere (self) {
  self = self || this
  const viewer = self.viewer
  viewer.scene.globe.showGroundAtmosphere = false
}

// 设置日月显示模式
function setSunMoonStatus (status, self) {
  const viewer = self.viewer
  if (status.sun === true || status.sun === false) {
    // viewer.scene.sun.show = false
    viewer.scene.sun.show = status.sun
  }
  if (status.moon === true || status.moon === false) {
    // viewer.scene.sun.show = false
    viewer.scene.moon.show = status.moon
  }
}

// 添加 基于 view 的部分
function setMapBackground (type, self) {
  self = self || this
  const viewer = self.viewer
  //  const viewer = this.viewer
  switch (type) {
    case 'transparent': {
      // skyBox 设置 为false 默认颜色设置为黑色
      viewer.scene.skyBox.show = false
      viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0)
      break
    }
    case 'black': {
      // skyBox 设置 为false 默认颜色设置为黑色
      viewer.scene.skyBox.show = false
      viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 1.0)
      break
    }
    case 'default': {
      viewer.scene.skyBox.show = true
      break
    }
    default: {
      break
    }
  }
}

export default {
  setCurrentTime,
  setTimeLineStatus,
  setAnimateStatus,
  openLighting,
  closeLighting,
  setLighting,
  openAtmosphere,
  closeAtmosphere,
  setMapBackground,
  setSunMoonStatus
}
